class Remodal {
  static instanceList = [];
  static overlayInit = false;
  static overlayState = "closed";
  static WindowState = "closed";
  static temporaryCallBack = null;

  constructor(element, type = "case") {
    this.ele = element;
    this.id = this.ele.getAttribute("data-remodal-id") ? this.ele.getAttribute("data-remodal-id") : null;
    this.state = "initialized";
    this.type = (() => {
      let type = this.ele.getAttribute("data-type") ? this.ele.getAttribute("data-type") : null;

      if (type !== null) {
        return type;
      } else {
        return "case";
      }

    })();
    this.wrapper = (() => {
      if (this.ele === null) return null;
      if (this.ele.parentNode && this.ele.parentNode.classList.contains("remodal-wrapper")) {
        return this.ele.parentNode;
      }
    })();
    this.openBtns = (() => {
      if (!this.id) return null;
      const targetData = '[data-modal-target="' + this.id + '"]';
      return document.querySelectorAll(targetData);
    })();
    this.closeBtns = (() => {
      if (!this.ele) return null;
      const targetData = '[data-remodal-action="close"]';
      return this.ele.querySelectorAll(targetData);
    })();

    this.openHandler = this.openEvent.bind(this);
    [...this.openBtns].forEach(btn => {
      btn.addEventListener("click", (e) => {
        this.openEvent(e)
      });
    });
    this.closeHandler = this.closeEvent.bind(this);
    if (this.closeBtns.length > 0) {
      [...this.closeBtns].forEach(btn => {
        btn.addEventListener("click", (e) => {
          this.closeEvent(e)
        });
      });
    }
    if (this.wrapper !== null && this.wrapper !== undefined) {
      this.wrapper.addEventListener("click", (e) => {
        if (e.target.classList.contains('remodal-wrapper')) {
          this.closeEvent(e);  // remodal-wrapperがクリックされた場合の処理
        }
      });
    }
  }

  closeEvent = async (e) => {
    if (e !== undefined) {
      // e.preventDefault();
    }
    if (!this.ele) return false;
    if (this.state === "closed" || this.state === "closing") return false;
    // Remodal.enableScroll();
    Remodal.overlayCloseEvent(this);
    await this.modalCloseAsync();

    if (Remodal.haveTemporaryCallBack()) {
      Remodal.burnTemporaryCallBack();
    }
  };

  modalCloseAsync = () => {
    return new Promise(resolve => {
      this.state = "closing";
      $(this.ele).removeClass("remodal-is-opened").addClass("remodal-is-closing");
      $(this.wrapper).removeClass("remodal-is-opened").addClass("remodal-is-closing");
      setTimeout(() => {
        $(this.ele).removeClass("remodal-is-closing").addClass("remodal-is-closed").hide();
        $(this.wrapper).removeClass("remodal-is-closing").addClass("remodal-is-closed").hide();
        this.state = "closed";
        resolve(); // Promiseを解決して非同期処理を完了させる
      }, 300); // 300ミリ秒（0.3秒）後にクラスを切り替える
    });
  }


  modalOpen = () => {

    this.state = "opening";
    $(this.ele).removeClass("remodal-is-closed").addClass("remodal-is-opening").show().css("display", "inline-block");
    $(this.wrapper).removeClass("remodal-is-closed").addClass("remodal-is-opening").show().scrollTop(0);

    setTimeout(() => {

      $(this.ele).removeClass("remodal-is-opening").addClass("remodal-is-opened");
      $(this.wrapper).removeClass("remodal-is-opening").addClass("remodal-is-opened");

      this.state = "opened";

    }, 300); // 300ミリ秒（0.3秒）後にクラスを切り替える

  }

  openEvent = (e) => {
    if (e !== undefined) {
      e.preventDefault();
    }
    if (!this.ele) return false;
    if (this.state == "opening" || this.state == "opened") return false;

    // Remodal.disableScroll();      
    this.modalOpen();
    Remodal.overlayOpenEvent(this);

  };

  static getInstanceFromId = (id) => {
    return Remodal.instanceList.filter(instance => {
      return instance.id == id;
    });
  }

  static getOpenInstance = () => {
    return Remodal.instanceList.filter(instance => instance.state == "opening" || instance.state == "opened");
  }


  static allModalClose = () => {
    let target = Remodal.getOpenInstance();
    if (target.length < 1) return false;
    [...target].forEach(instance => instance.closeEvent());
  }

  static overlayOpenEvent = (instance) => {

    if (Remodal.overlayState !== "closed" && Remodal.overlayState !== "closing") return false;

    //alert typeの場合、overlayの色をカスタマイズ
    if (instance.type === "alert") {
      $(".remodal-overlay").addClass("custom-overlay");
    }

    $(".remodal-overlay").removeClass("remodal-is-closed").addClass("remodal-is-opening").show();

    setTimeout(() => {
      $(".remodal-overlay").removeClass("remodal-is-opening").addClass("remodal-is-opened");
    }, 300); // 300ミリ秒（0.3秒）後にクラスを切り替える

    Remodal.overlayState = "opened";
  };

  static overlayCloseEvent = (instance) => {
    if (Remodal.overlayState !== "opened" && Remodal.overlayState !== "opening") return false;

    $(".remodal-overlay").removeClass("remodal-is-opened").addClass("remodal-is-closing");

    setTimeout(() => {
      $(".remodal-overlay").removeClass("remodal-is-closing").addClass("remodal-is-closed").hide();

      //alert typeの場合、overlayの色をカスタマイズ
      if (instance.type === "alert") {
        $(".remodal-overlay").removeClass("custom-overlay");
      }

    }, 300); // 300ミリ秒（0.3秒）後にクラスを切り替える

    Remodal.overlayState = "closed";
  };


  static getActiveModal = () => {
    return Remodal.instanceList.filter(instance => instance.state === "opened" || instance.state === "opening");
  }

  static getCaseInstanceList = () => {
    return Remodal.instanceList.filter(instance => instance.type === "case");
  }

  static checkExistBuildModal = (id) => {
    return Remodal.instanceList.filter(instance => instance.id == id)
  }
  static preventDefault = (e) => {
    e.preventDefault();
  }

  static disableScroll = () => {
    window.addEventListener('wheel', Remodal.preventDefault, {
      passive: false
    });
    window.addEventListener('mousewheel', Remodal.preventDefault, {
      passive: false
    });
    window.addEventListener('DOMMouseScroll', Remodal.preventDefault, {
      passive: false
    });
  }

  static enableScroll = () => {
    window.removeEventListener('wheel', Remodal.preventDefault, {
      passive: false
    });
    window.removeEventListener('mousewheel', Remodal.preventDefault, {
      passive: false
    });
    window.removeEventListener('DOMMouseScroll', Remodal.preventDefault, {
      passive: false
    });
  }

  static setTemporaryCallBack = (fn) => {
    Remodal.temporaryCallBack = fn;
  }

  static haveTemporaryCallBack = () => {
    return Remodal.temporaryCallBack !== null;
  }

  static burnTemporaryCallBack = () => {
    Remodal.temporaryCallBack();
    Remodal.temporaryCallBack = null;
  }

  static init = () => {
    // Remodal.generateOverlay();
    Remodal.generateDOM();


    let domList = document.querySelectorAll("[data-remodal-id]"); // domList の定義を追加

    Remodal.instanceList = [...domList].map(domItem => new Remodal(domItem));

    // console.log("Remodal.instanceList" , Remodal.instanceList );
  }

  static generateDOM = () => {
    let domList = document.querySelectorAll("[data-remodal-id]"); // domList の定義を追加

    if (domList.length > 0) {
      [...domList].forEach(remodalDiv => {
        var remodalWrapper = document.createElement("div");
        remodalWrapper.className = "remodal-wrapper";
        remodalWrapper.appendChild(remodalDiv);

        // remodal-wrapper要素を<body>タグの終了タグの直前に挿入
        document.body.insertBefore(remodalWrapper, document.body.lastChild);
      });
    }

  }


  static generateOverlay = () => {
    if (Remodal.overlayInit === true) return false;

    // // 新しいdiv要素を作成
    var remodalOverlay = document.createElement("div");
    remodalOverlay.className = "remodal-overlay";

    // // body要素の最後に追加
    document.body.insertBefore(remodalOverlay, document.body.lastChild);
    Remodal.overlayInit = true;
  }


  static destroy = () => {

    // "case" タイプのインスタンスだけを除外する
    const deleteList = Remodal.getCaseInstanceList();

    if (deleteList.length > 0) {

      // イベントリスナーの削除
      deleteList.forEach(instance => {

        if (instance.openBtns.length > 0) {
          [...instance.openBtns].forEach(btn => {
            btn.removeEventListener("click", instance.openHandler);
          });
        }
        if (instance.closeBtns.length > 0) {
          [...instance.closeBtns].forEach(btn => {
            btn.removeEventListener("click", instance.closeHandler);
          });
        }
        instance.wrapper.removeEventListener("click", instance.closeHandler);
        instance.wrapper.remove(); // "remodal-wrapper" クラスを持つ要素をDOMから削除

      });
    }



    // "case" タイプのインスタンスを instanceList から削除
    Remodal.instanceList = Remodal.instanceList.filter(instance => instance.type !== "case");


  }

  static rebuild = () => {
    Remodal.destroy();
    Remodal.init();
  }
}


export default Remodal;